import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import debounce from "lodash.debounce";
import Modal from "../../components/Modal/Modal";
import { useModal } from "../../shared/hooks/useModal";

import GenericTableComponent from "../../components/common/Table";
import {
  getAllPublishers,
  createPostbackSettings,
  getPostbackSettings,
} from "../../redux/slices/publisherSlice";
//import { convertToLocalCurrency } from '../../utils/currency';

const columns = [
  { id: "publisher_name", label: "Publisher" },
  { id: "campaigncount", label: "Campaign Count" },
  { id: "publisher_publisherUrl", label: "Url" },
  { id: "publisher_publisherReference", label: "Reference" },
  { id: "publisher_identifier", label: "Identifier" },
  { id: "publisher_clickIdParameter", label: "Click Id" },
  { id: "publisher_sourceIdParameter", label: "Source Id" },
  { id: "publisher_isActive", label: "Status" },
];
const PublishersTable = () => {
  const dispatch = useDispatch();
  const { publishers, meta, loading, postbackSetting } = useSelector(
    (state) => state.publisher
  );
  //console.log(publishers)

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const { showModal, hideModal, isModalOpen } = useModal();
  const [formData, setFormData] = useState({
    timeInterval: 0,
    range: 0,
    pbPublisher: 0,
    pbDigiClick: 0,
    staticId: parseInt(selectedId),
  });

  useEffect(() => {
    if (postbackSetting) {
      setFormData({
        timeInterval: parseInt(postbackSetting.timeInterval),
        range: parseInt(postbackSetting.range),
        pbPublisher: parseInt(postbackSetting.pbPublisher),
        pbDigiClick: parseInt(postbackSetting.pbDigiClick),
      });
    }
    dispatch(getAllPublishers({ page, rowsPerPage }));
  }, [dispatch, page, rowsPerPage, postbackSetting]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((searchTerm) => {
        dispatch(getAllPublishers({ page: 0, rowsPerPage, name: searchTerm }));
      }, 2000),
    [dispatch, rowsPerPage]
  );

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearch(value);
    debouncedSearch(value);
  };

  const triggerSearch = () => {
    dispatch(getAllPublishers({ page: 0, rowsPerPage, name: search }));
  };

  const handleFilterChange = (value) => {
    let boolValue;
    console.log(value);
    if (value === "ACTIVATED") {
      boolValue = true;
    } else if (value === "DEACTIVATED") {
      boolValue = false;
    } else {
      boolValue = null;
    }
    console.log(boolValue);
    dispatch(getAllPublishers({ page: 0, rowsPerPage, status: boolValue }));
  };

  // const handleActiveState = (id) => {
  //   dispatch(statusAdvertiser(id))
  //   .unwrap()
  //   .then(() => {
  //     dispatch(getAllPublishers({ page, rowsPerPage }));
  //   })
  //   .catch((error) => {
  //     console.error("Failed to update advertiser status:", error);
  //   });
  // };

  const handleViewClick = (id) => {
    setSelectedId(id); // Store the selected ID
    showModal("postbackSetting"); // Open the modal
    //console.log(id);
    dispatch(getPostbackSettings(id));
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "pbPublisher") {
      const publisherValue = Math.min(100, parseInt(value));
      setFormData((prev) => ({
        ...prev,
        pbPublisher: publisherValue,
        pbDigiClick: 100 - publisherValue, // Automatically calculate pbDigiClick
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: parseInt(value) }));
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(createPostbackSettings({ id: selectedId, formData })).then(() =>
      hideModal("postbackSetting")
    );
    setFormData({
      timeInterval: 0,
      range: 0,
      pbPublisher: 0,
      pbDigiClick: 0,
      staticId: null,
    });
  };

  const handleModalClose = () => {
    setSelectedId(null);
    hideModal("postbackSetting"); // Close the modal
    setFormData({
      timeInterval: 0,
      range: 0,
      pbPublisher: 0,
      pbDigiClick: 0,
      staticId: null,
    }); // Reset form data
  };
  return (
    <Container>
      {loading ? (
        <div> </div>
      ) : (
        <GenericTableComponent
          columns={columns}
          data={publishers}
          filterSearch={true}
          paginate={true}
          publisher
          // showModal={handleViewClick}
          viewLink="/view-publisher"
          editLink="/edit-publisher"
          campaignLink="/campaign-link"
          page={page}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          triggerSearch={triggerSearch}
          search={search}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handleSearchChange={handleSearchChange}
          totalItems={meta?.itemCount || 0}
          onFilterChange={handleFilterChange}
          hideDateSearch
          //handleActiveState={handleActiveState}
        />
      )}

      <Modal
        isOpen={isModalOpen("postbackSetting")}
        label="Postback Settings"
        handleClose={handleModalClose}
      >
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Postback Time Interval (mins)</label>
            <input
              type="number"
              name="timeInterval"
              value={formData.timeInterval}
              onChange={handleChange}
              min="0"
            />
          </div>

          <div className="form-group">
            <label>Minimum Postback</label>
            <input
              type="number"
              name="range"
              value={formData.range}
              onChange={handleChange}
              min="0"
            />
          </div>

          <div className="form-group">
            <label>Postback (Publisher) %</label>
            <input
              type="number"
              name="pbPublisher"
              value={formData.pbPublisher}
              onChange={handleChange}
              min="0"
              max="100"
            />
          </div>

          <div className="form-group">
            <label>Postback (ClickCircle) %</label>
            <input
              type="number"
              name="pbDigiClick"
              value={formData.pbDigiClick}
              onChange={handleChange}
              min="0"
              max="100"
              disabled
            />
          </div>

          <div className="submit">
            <div></div>
            <div className="submit-buttons">
              {/* <Link to='/campaigns'>
            <button className="cancel" type="submit" disabled={loading}>
              Pay Later
            </button></Link> */}
              <button className="add-campaign" type="submit" disabled={loading}>
                {loading ? "Saving..." : "Save Settings"}
              </button>
            </div>
          </div>

          {/* <button type="submit" disabled={loading}>
            {loading ? "Saving..." : "Save Settings"}
          </button> */}
        </form>
      </Modal>
    </Container>
  );
};

export const Container = styled.div`
  @media screen and (max-width: 568px) {
    .header {
      flex-direction: column;
      gap: 20px;
      h3 {
        font-size: 15px;
        color: #2b2f38;
      }
    }
  }
  .header {
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    .texts {
      h3 {
        font-size: 32px;
        line-height: 44px;
        color: #2b2f38;
      }
      p {
        margin-top: 5px;
        line-height: 22px;
        font-size: 16px;
        color: #667085;
      }
    }

    .link-buttons {
      display: flex;
      gap: 10px;
      .see-more,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        color: #344054;
      }
      .add-campaign {
        color: #fff;
        border: 1px solid #3730a3;
        background-color: #3730a3;
      }
    }
  }

  .form-group {
    margin-bottom: 1rem;

    label {
      margin-top: 20px;
      color: #344054;
      font-size: 14px;
    }

    input {
      width: 100%;
      //height: 43px;
      margin-top: 10px;
      border: solid 1px #e0e2e6;
      border-radius: 10px;
      padding: 12px 14px;
      transition: all 0.3s ease;

      &:focus {
        outline: #4f46e5;
        border: 1px solid #3730a3;
        background: transparent;
      }
    }

    /* label {
      display: block;
      margin-bottom: 0.5rem;
      font-weight: bold;
    }

    input {
      width: 100%;
      padding: 0.5rem;
      border: 1px solid #ccc;
      border-radius: 4px;
    } */
  }

  .submit {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    .submit-buttons {
      display: flex;
      gap: 10px;
      .cancel,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        color: #344054;
      }
      .add-campaign {
        color: #fff;
        border: 1px solid #3730a3;
        background-color: #3730a3;
      }
    }
  }
`;

export default PublishersTable;
